module.exports = __webpack_public_path__ + "static/3q2-a2a9f5fe924d1a1d794925762a9d5161.svg";